export default __webpack_public_path__ + "assets/295e7562b3eba101ad9ebc29658e5351.mp4";